"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDistributorVariant = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const routes_1 = require("../../routes");
const updateDistributorVariant = (client) => async (params, payload) => {
    const response = await client
        .put(routes_1.ENDPOINTS.UPDATE_DISTRIBUTOR_VARIANT.applyParams(params), {
        ...payload,
    })
        .catch((error) => {
        if (error instanceof axios_client_1.HttpError) {
            if (error.status === 422) {
                return { data: null };
            }
        }
        throw error;
    });
    return response.data;
};
exports.updateDistributorVariant = updateDistributorVariant;
